import React from 'react';

interface Props {
  className?: string;
}

export const EKlaseLogo: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    width="228"
    height="96"
    viewBox="0 0 228 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#eklase-logo-clip)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78.3929 95.7828H74.5257L65.9699 83.2081C63.139 86.0011 61.3697 87.7831 60.5988 88.6172V95.7828H57.4014V68.8389H60.5988V84.0928L75.8527 68.8389H78.9237V70.1532L78.6583 70.4818L68.3458 80.8449L78.4055 95.7828H78.3929Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M102.493 95.7828H80.9072V68.8389H84.1678V92.5854H102.493V95.7828Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.689 80.9202H122.867V79.4037C122.867 77.4574 122.109 75.7008 120.554 74.0326C118.911 72.8699 117.205 72.2506 115.499 72.2127C112.971 72.2127 111.025 73.0468 109.559 74.7529C108.295 76.2189 107.689 77.9882 107.689 80.1619V80.9202ZM126.064 95.7824H122.867V84.0544H107.752V95.7824H104.479V80.0988C104.491 76.8003 105.54 74.0705 107.626 71.9726C108.902 70.6456 110.81 69.6978 113.313 69.167C113.54 69.0785 114.046 69.0027 115.967 68.9521C117.938 69.1038 119.72 69.6725 121.376 70.6583C124.51 72.7435 126.09 75.7134 126.09 79.5048V95.7824H126.064Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M142.682 95.7821H128.047V92.6985H140.711C143.086 92.6985 143.731 92.4331 143.87 92.3573C145.563 91.5358 146.322 90.1836 146.322 88.0857C146.322 87.4664 146.056 86.6449 145.551 85.6466C145.121 84.9388 144.376 84.3954 143.289 84.0289L142.328 83.8773H134.581C133.014 83.8773 131.472 83.119 130.006 81.6151C128.755 79.9848 128.174 78.3671 128.174 76.7116V76.4209C128.174 73.906 129.197 71.8207 131.207 70.2157C132.673 69.3184 134.177 68.9014 135.756 68.9014H149.582V72.0356H136.805C134.657 72.0356 133.886 72.3136 133.621 72.4779C132.104 73.312 131.384 74.6137 131.384 76.4715C131.384 78.2028 132.155 79.4919 133.76 80.4145C134.531 80.6799 135.023 80.7431 135.302 80.7431H143.301C144.287 80.7431 145.424 81.198 146.802 82.1206L146.903 82.1964C148.647 83.7888 149.532 85.8235 149.532 88.25C149.532 91.1946 148.255 93.4441 145.753 94.9354C144.59 95.5041 143.579 95.7695 142.707 95.7695"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M173.126 95.7828H164.785C161.095 95.7828 157.746 94.2283 154.839 91.1826C153.715 89.7545 152.982 88.5539 152.552 87.4418C151.882 85.4829 151.553 83.7768 151.553 82.3108C151.553 80.4657 152.046 78.4183 153.032 76.2067C154.612 73.3379 156.823 71.2653 159.667 69.9636C161.487 69.2053 163.395 68.8262 165.367 68.8262H173.126V72.0867H165.202C161.803 72.0867 159.035 73.4769 156.773 76.3457C155.85 77.6348 155.231 79.1387 154.953 80.7942H167.414V83.9916H154.953C155.231 85.4703 155.8 86.8857 156.659 88.2253C157.923 89.9567 159.49 91.1952 161.272 91.8777C162.359 92.3832 163.837 92.6359 165.721 92.6359H173.126V95.7701V95.7828Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.5019 31.3037C32.1887 32.7949 0 44.6998 0 59.1323C0 68.3074 12.9538 76.4335 32.947 81.5392C18.0343 76.1302 8.82124 68.6739 8.82124 60.434C8.82124 46.1784 36.5108 34.2483 73.4893 31.291L73.5019 31.3037Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M154.498 31.3037C191.489 34.2483 219.166 46.1785 219.166 60.4467C219.166 68.6866 209.953 76.1429 195.04 81.5519C215.046 76.4462 227.987 68.3201 227.987 59.145C227.987 44.7125 195.799 32.8076 154.485 31.3163L154.498 31.3037Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M117.179 58.1845C98.6517 58.1845 83.3093 46.7978 80.491 31.8851C78.608 31.7208 76.7755 31.5312 74.9683 31.3037V31.3543C74.9683 48.5923 92.4338 62.5951 113.969 62.5951C132.963 62.5951 148.773 51.7139 152.236 37.2941C147.168 49.4643 133.368 58.1718 117.166 58.1718L117.179 58.1845Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M153.311 28.4984C151.592 12.5368 134.86 0 114.475 0C95.4803 0 79.6703 10.8812 76.2075 25.301C81.2753 13.1308 95.0759 4.42326 111.278 4.42326C128.579 4.42326 143.112 14.3566 147.232 27.816C140.838 27.1588 133.899 26.7923 126.519 26.8049C109.053 26.8429 93.8247 29.1177 81.5154 31.9107C90.6653 30.5837 100.7 29.8633 111.227 29.8633C126.797 29.8633 141.318 31.4304 153.412 34.2107C153.463 33.3008 153.488 32.3277 153.463 31.304V31.0765C153.463 30.5963 153.45 30.1034 153.412 29.6358C153.4 29.2441 153.362 28.8776 153.299 28.4984H153.311Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="eklase-logo-clip">
        <rect width="228" height="96" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
